import sessionCache from '@/utils/session_storage'
import request from '@/utils/request'


// 默认站点信息配置
const DEFAULT_SITE_INFO = {
    icp: {
        link: 'https://beian.miit.gov.cn/',
        number: ''
    },
    site_name: '',
    domain: '',
    site_logo: '',
    is_enable_sign_up: false,
    header_menus: [],
    is_enable_login: false
}

const fetchSiteInfo = async () => {
    try {
        // 异步获取站点信息
        const response = await request.get('/site/info')
        const siteInfo = response.data || DEFAULT_SITE_INFO
        sessionCache.set('SITE_INFO', siteInfo)
        return siteInfo
    } catch (error) {
        console.error('获取站点信息失败:', error)
        // 使用默认配置并存储
        sessionCache.set('SITE_INFO', DEFAULT_SITE_INFO)
        return DEFAULT_SITE_INFO
    }
}

// 获取缓存的站点信息
const getSiteInfo = () => {
    return sessionCache.get('SITE_INFO') || DEFAULT_SITE_INFO
}

export { fetchSiteInfo, getSiteInfo }
